import * as env from "util/env"

export const getMetaContentByName = (name) => {
  const sel = document.querySelector("meta[name='" + name + "']")
  return sel ? sel.getAttribute("content") : null
}

const _subdomain = env.getMetaContentByName("subdomain")
const _embedded = env.getMetaContentByName("embedded")
const initialRunId = env.getMetaContentByName("run-uuid")
const rootUrl = env.getMetaContentByName("root-url")
const antiForgeryToken = env.getMetaContentByName("__anti-forgery-token")
const subsessionToken = env.getMetaContentByName("__subsession-token")
const saveProgress = env.getMetaContentByName("save-progress")

export const getSubdomain = () => {
  return _subdomain === "" ? null : _subdomain
}

export const isEmbedded = () => {
  return _embedded ? JSON.parse(_embedded) : false
}

export const getInitialRunId = () => initialRunId

export const getAntiForgeryToken = () => antiForgeryToken
export const getSubsessionToken = () => subsessionToken
export const getTokens = () => ({csrf: antiForgeryToken, subsession: subsessionToken})
export const allowSaveProgress = () => saveProgress !== "off"

export const getRootUrl = () => rootUrl

export const isDemo = () => {
  try {
    // First check if we're in an iframe
    const isIframe = window.self !== window.top;
    console.log('[Demo Check] Is iframe:', isIframe);
    if (!isIframe) return false;

    // Check if we're in a story iframe (coach path)
    const isStoryIframe = window.location.pathname.includes('/coach/');
    console.log('[Demo Check] Is story iframe:', isStoryIframe);
    
    if (!isStoryIframe) return false;

    // Set up a promise to wait for the parent's response
    return new Promise((resolve) => {
      // Set up message listener
      const messageHandler = (event) => {
        if (event.origin === 'http://localhost:3000') {
          console.log('[Demo Check] Received message:', event.data);
          if (event.data.type === 'PARENT_LOCATION') {
            // Clean up listener
            window.removeEventListener('message', messageHandler);
            const isDemoPath = event.data.pathname?.includes('demo') || event.data.hash?.includes('demo');
            console.log('[Demo Check] Is demo path:', isDemoPath);
            resolve(isDemoPath);
          }
        }
      };

      // Add message listener
      window.addEventListener('message', messageHandler);

      // Request location info from parent
      console.log('[Demo Check] Requesting parent location');
      window.parent.postMessage({ type: 'GET_PARENT_LOCATION' }, 'http://localhost:3000');

      // Timeout after 1 second
      setTimeout(() => {
        window.removeEventListener('message', messageHandler);
        console.log('[Demo Check] Timeout waiting for parent response');
        resolve(false);
      }, 1000);
    });
  } catch (e) {
    console.error('[Demo Check] Error checking demo status:', e);
    return false;
  }
}
